module.exports = __webpack_public_path__ + "static/media/wishpanda-badge.9e1e5fa7.png";